import React from 'react';
import { MissionIcon } from 'assets/icons';

// These headers are the sticky menu: En cours, À venir, Passées take turns
// pinned at the top as the list scrolls past them. The panel scrolls in its
// content area, not in SlideOverBody, and the filter bar sits outside that
// area — so a header sticks flush at its top rather than under a second
// sticky row.
export const SECTION_STICKY_TOP = 'top-0';

// A sticky header should span the full width of its scroll container. How much
// padding it has to cancel to get there depends on that container, which
// differs per panel — so each panel passes its own `gutterClass`. Getting this
// wrong on a padding-less scroller overflows it, and since `overflow-y: auto`
// forces `overflow-x`, that shows up as a horizontal scrollbar.

const TONES = {
  current: { bg: 'bg-green-100', icon: '#059669' },
  future: { bg: 'bg-blue-100', icon: '#3B82F6' },
  past: { bg: 'bg-gray-100', icon: '#6B7280' },
};

const MissionListSection = ({ label, count, tone, gutterClass = '', children }) => {
  if (!count) return null;

  const { bg, icon } = TONES[tone] || TONES.past;

  return (
    <div className={'flex flex-col'}>
      <div
        data-section-header
        className={`sticky ${SECTION_STICKY_TOP} z-10 bg-white flex items-center gap-3 py-2 ${gutterClass}`}
      >
        <div
          data-section-icon
          className={`${bg} w-8 h-8 flex justify-center items-center rounded-lg flex-shrink-0`}
        >
          <MissionIcon wh={18} color={icon} />
        </div>
        <div className={'uppercase tracking-wide text-gray-700 font-medium'}>
          {label}
        </div>
        <div
          className={
            'ml-auto bg-yellow-100 text-yellow-800 rounded px-1.5 flex items-center justify-center min-w-[20px] text-xs'
          }
        >
          {count}
        </div>
      </div>
      <div className={'divide-y divide-gray-100'}>{children}</div>
    </div>
  );
};

export default MissionListSection;
